import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Spinner, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import BreadCrumb from "../BreadCrumb";
import { emailList } from "../../store/actions/councilActions/emailActions";
import {
  contactList,
  getHelpline,
} from "../../store/actions/councilActions/contactActions";
import Pagination from "../misc/Pagination";

const breadcrumbs = [
  {
    path: "/",
    label: "Home",
  },
  {
    label: "Important Contacts",
  },
];

const ImpContacts = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [helpline, setHelpline] = useState("");
  const [data, setData] = useState([]);
  const [activePage, setactivePage] = useState(1);
  const [totalPages, settotalPages] = useState(0);

  const fetchdata = useCallback(async () => {
    const response = await dispatch(contactList(activePage));
    if (response) {
      setData(response.data);
      settotalPages(Math.ceil(response.total / response.per_page));
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [activePage, dispatch]);
  const fetchHelpline = async () => {
    const response = await dispatch(getHelpline());
    if (response) {
      setHelpline(response);
    } else {
    }
  };
  useEffect(() => {
    setLoading(true);
    fetchdata();
  }, [fetchdata]);
  useEffect(() => {
    fetchHelpline();
  }, []);

  return (
    <div>
      {" "}
      <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
        <div class="subheader py-2 py-lg-6 subheader-solid" id="kt_subheader">
          <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
            <BreadCrumb crumbs={breadcrumbs} />
          </div>
        </div>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" role="status" size="lg">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Table bordered hover striped responsive className="mb-0">
            <thead>
              <th>S No</th>
              <th>Department</th>
              <th>Department Designation</th>
              <th>Name of the Head</th>
              <th>Phone No.</th>
            </thead>
            <tbody>
              <tr>
                <td colSpan={5}>
                  {helpline && (
                    <marquee direction="left">
                      सामान्य पूछताछ हेतु : {helpline.mobile}
                    </marquee>
                  )}
                </td>
              </tr>
              {data.length == 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-danger">
                    No Record Found
                  </td>
                </tr>
              ) : (
                data.map((element, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{element.department}</td>
                    <td>{element.depart_designation}</td>
                    <td>{element.name}</td>
                    <td>{element.phone}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
        {totalPages && Number(totalPages) !== 0 ? (
          <Pagination
            setActivePage={(value) => setactivePage(value)}
            totalPages={totalPages}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ImpContacts;
